import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
//@ts-ignore
import moment from "moment";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router/DispatchManifestRouter";
import { orderRemarksValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const Remark = (props: any) => {
  const { data: defaultBranch } = useGetHook({
    queryKey: ["default_branch"],
    url: `${APIS.BRANCH}default-branch`,
    params: {},
  });
  const { data: remarks } = useGetHook({
    queryKey: [`remakrs-${props?.selectedID}-${props?.receiver}`],
    url: APIS.COMMENT,
    params: {
      limit: 200,
      offset: 0,
      object_id: props?.selectedOrder,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`remakrs-${props?.selectedID}-${props?.receiver}`],
    navigateURL: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<any>({
    resolver: yupResolver(orderRemarksValidationForm),
  });

  const handleCreateReview = async (data: any) => {
    const url = `${APIS.COMMENT}`;
    let formData = {
      ...data,
      branch: defaultBranch?.id,
      object_id: props?.selectedOrder,
    };
    try {
      await mutateAsync({ url, formData, setError });
      reset();
      queryClient.refetchQueries();
    } catch (err) {
      console.log(err);
    }
  };

  // copied code from https://flowbite.com/blocks/publisher/comments/

  return (
    <>
      <section className={tw`bg-white  mt-4`}>
        <div className={tw`max-w-2xl mx-auto px-4`}>
          <div className={tw`sticky top-4`}>
            <div className={tw`flex justify-center uppercase`}>
              {props?.receiver}
            </div>
            <form className={tw`mb-6`}>
              <div
                className={tw`py-2 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 `}
              >
                <textarea
                  id="comment"
                  rows={6}
                  {...register("comment")}
                  className={tw`px-0 w-full text-sm bg-white text-gray-900 border-0 focus:ring-0 focus:outline-none `}
                  placeholder="Write a comment..."
                  required
                ></textarea>
              </div>
              <div className={tw`flex justify-end w-full`}>
                <div className={tw`w-[100px] mr-4`}>
                  <Button
                    label={"Create"}
                    isLoading={isPostLoading}
                    onClick={handleSubmit((data: any) =>
                      handleCreateReview(data)
                    )}
                  />
                </div>
              </div>
            </form>
          </div>
          {remarks?.results?.map((item: any, index: number) => (
            <article
              className={tw`p-6 text-base bg-white border-t border-gray-200 `}
              key={index}
            >
              <footer className={tw`flex justify-between  mb-2`}>
                <div className={tw`flex `}>
                  <div className={tw`flex justify-start  gap-x-2 `}>
                    <div
                      className={tw`w-12 h-12 rounded-full bg-gray-300 items-center justify-center flex`}
                    >
                      <p className={tw`text-4xl text-primary`}>
                        {item?.user.is_superuser
                          ? item?.user?.name?.slice(0, 1)
                          : "Staff".slice(0, 1)}
                      </p>
                    </div>
                    <div>
                      <p
                        className={tw`inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white`}
                      >
                        {item?.user.is_superuser ? item?.user.name : "Staff"}
                      </p>
                      <p className={tw`text-sm text-gray-900`}>{item?.branch}</p>
                    </div>
                  </div>

                  <p
                    className={tw`text-sm text-gray-600 dark:text-gray-400  ms-2 `}
                  >
                    {moment(item?.created).format("YYYY-MM-DD hh:mm:ss A")}
                  </p>
                </div>
              </footer>
              <p className={tw`text-gray-500  ml-14`}>{item?.comment}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Remark;
